import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { itemsFetchCategories } from '../actions/index'
import { setActiveCategory } from '../actions/index'
import { connect } from 'react-redux'
import ProtectedContent from './ProtectedContent'
import RightArrow from '../images/tail-right.svg'


class CategoryList extends React.Component {

    componentDidMount() {
        this.props.fetchData()
    }

    renderLoadingMessage = () => {
      if (this.props.hasErrored) {
        return <p>Sorry! There was an error loading the items</p>;
        }
        if (!this.props.categories.length && this.props.isLoading) {
        return (
        <div className="spinner">
          <div className="bounce1"></div>
          <div className="bounce2"></div>
          <div className="bounce3"></div>
        </div>
        )
      }
    }


    render() {

    


    return(

        

      <div>
        <Header />

        



        { (Object.keys(this.props.user).length) 

        ?

        <div className="container">

          <h1 style={{marginTop: 0, textAlign: 'center'}}>Forum</h1>

          {this.renderLoadingMessage()}

          {this.props.categories.map( category => 
            <Link style={{textDecoration: 'none'}} to={"/" + category._id} key={category._id}>
              <div className="category-item" onClick={() => this.props.setActiveCategory(category)}>
                
                  <div>
                  <p className="category-item-name">{category._id}</p>
                  <p style={{fontSize: 14, color: 'black'}} className="category-item-count">{category.count} discussions</p>
                  </div>
                
                
                  <img alt="" style={{ width: 30, paddingRight: 20 }} src={RightArrow} />
                
              </div>
            </Link> )}

            

            

          

          

        </div>

        : 

        <ProtectedContent />

        }

        <Footer />

      </div>
    )
  }
}

const mapStateToProps = (state) => {
    return {
        categories: state.categories,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading,
        user: state.user
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => dispatch(itemsFetchCategories()),
        setActiveCategory: (category) => dispatch(setActiveCategory(category))
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(CategoryList)




// WEBPACK FOOTER //
// ./src/components/CategoryList.js